// import Vue from 'vue'   //引入Vue
import {
	createRouter,
    createWebHistory
} from 'vue-router' //引入vue-router
// Vue.use(Router)  //Vue全局使用Router

import home from '@/views/home.vue'
import detail from '@/views/detail.vue'
import categorize from '@/views/categorize.vue'
import marvelExhibition from '@/views/marvelExhibition.vue'
import contribute from '@/views/contribute.vue'
import personal from '@/views/personal.vue'
import login from '@/views/login.vue'
const routes = [
	{
		path: '',
		redirect: "home"
	},
	{
		path: '/home',
		name: 'home',
		component: home,
		meta: {
			title: '七悦剧场'
		}
	},
	{
		path: '/detail',
		name: 'detail',
		component: detail,
		meta: {
			title: '详情'
		}
	},
	{
		path: '/categorize',
		name: 'categorize',
		component: categorize,
		meta: {
			title: '分类'
		}
	},
	{
		path: '/marvelExhibition',
		name: 'marvelExhibition',
		component: marvelExhibition,
		meta: {
			title: '漫展'
		}
	},
	{
		path: '/contribute',
		name: 'contribute',
		component: contribute,
		meta: {
			title: '投稿'
		}
	},
	{
		path: '/personal',
		name: 'personal',
		component: personal,
		meta: {
			title: '个人中心'
		},
		children: [
			{
				path: 'personalComponents/personalCenter',
				name: 'personalCenter',
				meta: {
					title: '个人中心'
				},
				component: () => import('@/views/personalComponents/personalCenter.vue')
      },
			{
				path: 'personalComponents/userAgreement',
				name: 'userAgreement',
				meta: {
					title: '用户协议'
				},
				component: () => import('@/views/personalComponents/userAgreement.vue')
      },
			
    ]
	},
	{
		path: "/rankList",
		name: "rankList",
		component: () => import('@/views/rankList.vue'),
		meta: {
			keepAlive: true,
			title: "排行榜"
		}
	},
	{
		path: "/searchPage",
		name: "searchPage",
		component: () => import('@/views/searchPage.vue'),
		meta: {
			keepAlive: true,

		}
	},
	{
		path: "/comicContent",
		name: "comicContent",
		component: () => import('@/views/comicContent.vue'),
		meta: {
			keepAlive: true,
		}
	},
	{
		path: "/login",
		name: "login",
		component: () => import('@/views/login.vue'),
		meta: {
			keepAlive: true,
		}
	},
	{
		path: '/:pathMatch(.*)',
		redirect: '/404',
		children: [
		  {
			path: '/404', // 这里要加上/404,和上面的redirect对应,必须加上/
			name: '404',
			component: () => import('@/components/404'),
		  },
		],
	  },
];
 
const router = createRouter({
	history: createWebHistory(),
	routes
})
// 导航守卫
// 使用 router.beforeEach 注册一个全局前置守卫，每次跳转页面回到顶部
router.beforeEach((to, from, next) => {
    // 路由跳转后，让页面回到顶部
    document.body.scrollTop = 0; 
    document.documentElement.scrollTop = 0; 
	// window.pageYOffset = 0

    // 调用 next()，一定要调用 next 方法，否则钩子就不会被销毁!!
    next();
  });
export default router;